<template>

  <v-dialog max-width="400px">
    <v-btn class="env"
           slot="activator"
           :small="true"
           color="primary">{{ env }}</v-btn>
    <v-card>
      <v-card-text>
        <v-container fluid="fluid" grid-list-xl="grid-list-xl">
          <v-btn v-for="e in envlist"
                 :key="e"
                 :small="true"
                 color="primary"
                 @click.native="selectEnv(e)"
                 :disabled="e === env">{{ e }}</v-btn>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>

import Popup from '@/components/Popup'
import env from '@/tools/env'
import Button from '@/components/common/Button'

export default {
  name: 'EnvSelector',
  components: {
    Popup,
    Button
  },
  data () {
    return {
      isSelecting: false,
      env,
      envlist: ['dev', 'preprod', 'prod']
    }
  },
  methods: {
    selectEnv (e) {
      if (e !== env) {
        this.$router.push('/' + e)
      }
      this.isSelecting = false
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/EnvSelector.vue